import { useQuery } from '@tanstack/react-query';
import { listReleaseProposals } from 'services/api/NumberRegistrationAPI';
import { queryKeys } from '../queryKeys';

export const useGetReleaseProposals = (tenantId: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: queryKeys.releaseProposals(tenantId),
        queryFn: () => listReleaseProposals(tenantId),
        // No tenant means no endpoint to call: the tab renders an empty picker
        // until one is chosen.
        enabled: Boolean(tenantId),
    });

    return {
        releaseProposals: data?.proposals ?? [],
        isReleaseProposalsLoading: isLoading,
        releaseProposalsError: error,
    };
};
